module.exports = __webpack_public_path__ + "media/img/pay-7-59b52dcfdcd91fd4c609d0e5e083e16c.svg";